export default async ({ $api, $cookies, $honeybadgerGeneric, store }) => {
  if (store.getters['utils/getApiTokens']) {
    return;
  }

  const apiTokens = $cookies.get('bonkers-ie-api-token');

  if (typeof apiTokens === 'object') {
    setApiTokens($cookies, store, apiTokens);
    return;
  }

  try {
    const response = await $api('util/sessions/tokens');

    if (response && response.id) {
      delete response.id;
      setApiTokens($cookies, store, response);
    }
  } catch (error) {
    $honeybadgerGeneric.notify(error, {
      name: 'API Token Error',
      context: {
        message: 'Error getting tokens',
        response: error.response,
        status: error.response && error.response.status
      }
    });
    setApiTokens($cookies, store, null);
  }
};

const setApiTokens = ($cookies, store, tokens) => {
  $cookies.set('bonkers-ie-api-token', tokens);
  store.commit('utils/setApiTokens', tokens);
};
